module.exports = __webpack_public_path__ + "img/s2_t2_01.0a0e9696.jpeg";